"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const JobCentricAppPicker_1 = require("../JobCentricAppPicker");
const headerStyles = core_1.css `
  ${design_system_1.Typography.subtitle800}
  color: ${design_system_1.Colors.black};
  border-bottom: 1px solid ${design_system_1.Colors.grey300};
  padding: 20px;
`;
function JobCentricAppPickerModal(props) {
    const { onClose } = props, pickerProps = __rest(props, ["onClose"]);
    const { isTrigger } = props;
    return (core_1.jsx(common_components_1.Modal, { closeOnOutsideClick: true, margin: 20, maxWidth: 915, onClose: onClose, padding: 0 },
        core_1.jsx("section", { css: headerStyles },
            "Change ",
            isTrigger ? 'trigger' : 'action'),
        core_1.jsx(JobCentricAppPicker_1.JobCentricAppPicker, Object.assign({}, pickerProps))));
}
exports.default = JobCentricAppPickerModal;
